/**
 * Brazilian Portuguese (pt-BR) mappings for MessageInput
 */

export const messageInputPtBR = {
  // Placeholder text
  "Ask Away!": "Pergunte!",
  
  // UI elements
  "Ideas": "Ideias",
  "PickStar Quick AI Suggestions": "Sugestões Rápidas de IA PickStar",
  "Upgrade for 2K characters": "Atualize para 2 mil caracteres",
  "remaining": "restantes",
  
  // Caution message
  "AI analysis offer insights, not guarantees—use responsibly.": "As análises de IA oferecem insights, não garantias—use com responsabilidade."
};